import { getCertificationStatus } from './queries/hotelX/get-certification-status';
import { writeCertificationStatus } from './mutations/hotelX/write-certification-status';

export const hotelXQueries = {
  getCertificationStatus: getCertificationStatus,
};

export const hotelXMutations = {
  writeCertificationStatus: writeCertificationStatus,
};

export class CertificationInput {
  organizationCode: string;
  name?: string;
}
